
<script>
import { ref, onUnmounted } from 'vue'
// import { io } from "socket.io-client"; //npm i socket.io-client (https://www.npmjs.com/package/socket.io-client)
// import { PaymentQRCodeSocketModel } from '../model/PaymentQrModel' 
export default {
    setup(){ 
        const  isConnected = ref(false)
        const  statusText = ref("")
        const  dataText = ref("")
        // const socket = io();
        // const socketQrPayment = () => {

        //     //return new Promise((resolve) => {
        //         socket.on('disconnect', function (err) { 
        //             //console.log('disconnect network', err)
        //             statusText.value = "disconnect network " + err
        //             isConnected.value = false
        //         });
        //         socket.on('connect_error', function (err) { 
        //             //console.log('connect error' , err) 
        //             statusText.value = "connect error " + err
        //             isConnected.value = false
        //         });
        //         socket.on("connect", () => {
        //             //console.log(socket.id);
        //             isConnected.value = true
        //             statusText.value = "connect network " + socket.id
        //             //resolve(true)
        //         });
        //         socket.on('qr_payment', (data) => {
        //             //console.log("qr_payment", data)
                    
        //             dataText.value = "qr_payment " + JSON.stringify(data);

        //             const qrCodeModel = new PaymentQRCodeSocketModel().setDataFromApi(data)
        //             console.log(qrCodeModel) 
        //             //if (qrCodeModel.success) {
        //                 //if (transactionId.value == qrCodeModel.tranId) {
        //                     //socket.disconnect() 
        //                 //}
        //             //}
        //         })
        //     //})

        // }

        //socketQrPayment()
        
        onUnmounted(() => {
            // socket.disconnect()
        })

        return { 
            isConnected,
            statusText,
            dataText,
        }
    },
}
</script>
<template>
    <div>
        isConnected : {{isConnected}} 
        <br/>
        statusText: {{ statusText }}
        <br/>
        dataText: {{ dataText }}
    </div>

</template>
